// Guilds e cerco de castelo (documento de design). Cerco assíncrono: cada fortaleza de Noxara está ligada a uma faixa
// de level; durante a semana, cada abate de um membro numa hunt dessa faixa vale pontos para a guild (a experiência base
// do monstro / 100). No domingo às 20h (Brasília) a guild com mais pontos toma a fortaleza até o próximo cerco, e os
// membros ganham o bônus da fortaleza ao caçar naquela faixa. Frequência e recompensas eram pontos em aberto: proposta.
export const GUILD_CREATE_GOLD = 500_000;
export const GUILD_MAX = 100;
export const GUILD_NAME = /^[A-Za-zÀ-ÿ' ]{3,24}$/;
export type GuildRank = 'leader' | 'vice' | 'member';
export const RANK_NAMES: Record<GuildRank, string> = { leader: 'Líder', vice: 'Vice-líder', member: 'Membro' };
export interface Fortress { id: string; name: string; min: number; max: number; bonus: number }
export const FORTRESSES: Fortress[] = [
  { id: 'norte', name: 'Fortaleza do Norte', min: 1, max: 149, bonus: 3 },
  { id: 'rubra', name: 'Fortaleza Rubra', min: 150, max: 499, bonus: 3 },
  { id: 'sombria', name: 'Fortaleza Sombria', min: 500, max: 99999, bonus: 3 },
];
export const fortressFor = (huntLevel: number) => FORTRESSES.find((f) => huntLevel >= f.min && huntLevel <= f.max);
/** semana do cerco: termina no domingo às 20h de Brasília */
export function siegeWeek(now = Date.now()): { id: string; ends: number } {
  const WEEK = 7 * 86400_000, EPOCH = Date.UTC(2026, 0, 4, 23); // domingo 04/01/2026 20h BRT
  const n = Math.floor((now - EPOCH) / WEEK);
  return { id: 'w' + (n + 1), ends: EPOCH + (n + 1) * WEEK };
}
export interface GuildInfo { id: number; name: string; motd: string; members: Array<{ id: number; name: string; vocation: string; level: number; rank: GuildRank; online: boolean }> }
